import React, { useContext, useState } from 'react'
import moment from 'moment'
import BigModal from '../../../../../components/Modals/BigModal'
import CustomDataGrid from '../../../../../components/DataGrid/CustomDataGrid'
import AddNewInsurance from './AddNewInsurance'
import Button from '@mui/material/Button'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import AddIcon from '@mui/icons-material/Add'
import AttachmentIcon from '@mui/icons-material/Attachment'
import { VehicleContext } from '../../SingleVehicle'
import { Alert } from '@mui/material'
import InsuranceModal from './InsuranceModal'
import { TenantSettingsContext } from '../../../../../App'
import { SectionHeader } from '../SectionKit'

const Insurance = ({ }) => {
  const [openAddNew, setOpenAddNew] = useState(false)
  const [selectedInsurance, setSelectedInsurance] = useState(null)
  const { vehicle } = useContext(VehicleContext)
  const { orgSettings } = useContext(TenantSettingsContext).orgConfig

  const sortedInsurance = vehicle?.insurance
    ? [...vehicle.insurance].sort(
      (a, b) => moment(b.dateFrom) - moment(a.dateFrom),
    )
    : []

  return (
    <Stack spacing={1.5}>
      <SectionHeader
        title="Insurance"
        action={
          <Button
            variant="outlined"
            size="small"
            onClick={() => setOpenAddNew(true)}
            startIcon={<AddIcon />}
          >
            Add Insurance
          </Button>
        }
      />
      {vehicle?.insurance?.length >= 1 ? (
        <CustomDataGrid
          rows={sortedInsurance}
          columns={[
            {
              field: 'dateFrom',
              renderCell: ({ value }) =>
                moment(value).format('DD/MM/YYYY HH:mm'),
              minWidth: 160,
              headerName: 'Valid From',
            },
            {
              field: 'dateTo',
              renderCell: ({ value }) =>
                moment(value).format('DD/MM/YYYY HH:mm'),
              minWidth: 160,
              headerName: 'Valid Until',
            },
            {
              field: 'provider',
              headerName: 'Provider',
              minWidth: 150,
              flex: 1,
            },
            {
              field: 'policyNo',
              headerName: 'Policy Number',
              minWidth: 150,
              flex: 1,
            },
            {
              field: 'cost',
              headerName: 'Cost',
              minWidth: 110,
              renderCell: ({ value }) =>
                value != null ? `${orgSettings?.currency ?? '£'}${Number(value).toFixed(2)}` : '—',
            },
            {
              field: 'documents',
              headerName: 'Documents',
              minWidth: 100,
              align: 'center',
              headerAlign: 'center',
              renderCell: ({ value }) => (
                <Box
                  alignItems="center"
                  justifyContent="center"
                  width="100%"
                  height="100%"
                  display="flex"
                >
                  {value.length >= 1 && <AttachmentIcon color="primary" />}
                </Box>
              ),
            },
          ]}
          getRowId={(params) => params._id}
          maxHeight={200}
          slots={{
            footer: () => null,
            toolbar: () => null,
          }}
          disableRowSelectionOnClick
          onRowClick={({ row }) => setSelectedInsurance(row)}
        />
      ) : (
        <Alert severity="info">No Insurance Records Yet</Alert>
      )}
      <BigModal
        open={openAddNew}
        onClose={() => setOpenAddNew(false)}
      >
        <AddNewInsurance
          vehicle={vehicle}
          onClose={() => setOpenAddNew(false)}
        />
      </BigModal>
      <BigModal
        open={!!selectedInsurance}
        onClose={() => setSelectedInsurance(null)}
        hideBackgroundColor
      >
        <InsuranceModal insurance={selectedInsurance} onClose={() => setSelectedInsurance(null)} />
      </BigModal>
    </Stack>
  )
}

export default Insurance
